import { z } from "zod";

const schema = z.object({
    projects: z.array(
        z.object({
            id: z.string().min(1, { message: "Required" }),
            name: z.string().min(1, { message: "Required" }),
            elements: z.array(
                z.object({
                    name: z.string().min(1, { message: "Required" }),
                    value: z.string().min(1, { message: "Required" }),
                    id: z.string().min(1, { message: "Required"}),
                    options: z.array(
                        z.object({
                            key: z.string().optional(),
                            value: z.string().optional(),
                        })
                    ).optional(),

                })
            ).optional(),
        })
    )
})

type schemaType = z.infer<typeof schema>;

export {
    schema,
    type schemaType
}